import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { LayoutEnum } from 'src/app/shared/enum/panel/layout.enum';
import { AlertService, AlertType } from 'src/app/shared/services/alert.service';
import { VerifyWaitingTimeService } from 'src/app/shared/services/API/queue/verify-waiting-time.service';
import { HealthUnitTimeService } from 'src/app/shared/services/API/user/health-unit-time.service';
import { AuthService } from 'src/app/shared/services/auth.service';
import { GetQueueRequest } from 'src/app/shared/services/requests/queue/get-queue.request';
import { GetPanelResponse } from 'src/app/shared/services/responses/panel/get-panel.response';
import { KeepAliveService } from 'src/app/shared/services/API/panel/keep-alive.service';
import { ActivatedRoute, Router } from '@angular/router';
import { UtilsClientService } from 'src/app/client/utils.service';

@Component({
  selector: 'app-display-options',
  templateUrl: './display-options.component.html',
  styleUrls: ['./display-options.component.css']
})
export class DisplayOptionsComponent implements OnInit {

  constructor(private alertService: AlertService,
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private authService: AuthService,
    private utilsClientService: UtilsClientService,
    private verifyWaitingTimeService: VerifyWaitingTimeService,
    private healthUnitTimeService: HealthUnitTimeService,
    private KeepAliveService: KeepAliveService,
  ) { }

  selectedTemplate: number | null = null;

  public layoutPrincipal: LayoutEnum = LayoutEnum.LayoutPrincipal;
  public layoutEsquerda: LayoutEnum = LayoutEnum.LayoutEsquerda;
  public layoutDireita: LayoutEnum = LayoutEnum.LayoutDireita;
  public layoutPrincipalV2: LayoutEnum = LayoutEnum.LayoutPrincipalV2;

  public panelStruct: GetPanelResponse = new GetPanelResponse();

  public logoString64: string = '';
  public videoFormat: string = '';
  public lastHourWaitingTimeAverage: string | null = null;

  public idLayout: number | null = null;
  public idPanel: number | null = null;

  public isLoading: boolean = false;
  public firstLoading: boolean = true;
  public showAverageWaitingTime: boolean = false;
  public firstAuthenticated: boolean = true;

  public panelTime: Date | null = null;

  ngOnInit(): void {
    this.idPanel = parseInt(this.activatedRoute.snapshot.paramMap.get('id')!);
    this.panelStruct = this.authService.getPanelToken();
    this.firstAuthenticated = this.utilsClientService.getAuthenticated();

    if (!this.panelStruct) {
      this.router.navigate(['/client/display/' + this.idPanel]);
      return;
    }

    this.idLayout = this.panelStruct.idLayout;
    this.videoFormat = this.panelStruct.videoFormat;

    this.verifyWaitingTime();
    this.getHealthUnitTime();

    if (this.idLayout == LayoutEnum.LayoutEsquerda)
      this.setTemplate(LayoutEnum.LayoutEsquerda);
    else if (this.idLayout == LayoutEnum.LayoutDireita)
      this.setTemplate(LayoutEnum.LayoutDireita);
    else if (this.idLayout == LayoutEnum.LayoutPrincipalV2)
      this.setTemplate(LayoutEnum.LayoutPrincipalV2);
    else
      this.setTemplate(LayoutEnum.LayoutPrincipal);

    this.utilsClientService.removeAuthenticated();
  }

  setTemplate(template: number) {
    this.selectedTemplate = template;
  }

  keepAlive() {
    this.KeepAliveService.keepAlive().subscribe({
      next: (response) => {
      },
      error: (error) => {
        console.log(error);
        this.alertService.show('Erro inesperado', error, AlertType.error);
      }
    });
  }

  verifyWaitingTime() {
    let panel = this.panelStruct?.listPanelOrigin?.find(x => x.showAverageWaitingTime);
    if (!panel)
      return;

    this.showAverageWaitingTime = panel.showAverageWaitingTime;

    let request: GetQueueRequest = new GetQueueRequest();
    request.idRoom = panel.idRoom;
    request.idSector = panel.idSector;
    request.idService = panel.idService;

    this.isLoading = true;
    this.verifyWaitingTimeService.getVerifyWaitingTime(request).subscribe({
      next: (response) => {
        if (response.isError) {
          this.alertService.show('Erro', response.errorDescription, AlertType.error);
          this.isLoading = false;
          return;
        }

        this.lastHourWaitingTimeAverage = response.lastHourWaitingTimeAverage;
        this.isLoading = false;
      },
      error: (error) => {
        console.log(error);
        this.isLoading = false;
        this.alertService.show('Erro inesperado', error, AlertType.error);
      }
    });
  }

  getHealthUnitTime() {
    this.isLoading = true;
    this.healthUnitTimeService.getTime(this.panelStruct.idHealthUnit!).subscribe({
      next: (response) => {
        if (response.isError) {
          this.alertService.show('Erro', response.errorDescription, AlertType.error);
          this.isLoading = false;
          this.firstLoading = false;
          return;
        }

        this.panelTime = response.healthUnitTime;
        this.isLoading = false;
        this.firstLoading = false;
      },
      error: (error) => {
        console.log(error);
        this.isLoading = false;
        this.firstLoading = false;
        this.alertService.show('Erro inesperado', error, AlertType.error);
      }
    });
  }
}